import {CreateAccessor} from "mobx-graphlink";
import {O} from "web-vcore";
import {InAndroid} from "../../../Utils/Bridge/Bridge_Native";

export class SoundsState {
	@O accessor youtubePlayersToKeepBuffered = InAndroid(0) ? 1 : 3;
}

export const GetYoutubePlayersToKeepBuffered = CreateAccessor({ctx: 1}, function() {
	return this.store.main.engine.sounds.youtubePlayersToKeepBuffered;
});